import { WallboxStatusDto } from '../../dto/wallbox-status.dto'
import { WallboxStatusModel } from '../../models/wallbox-status/wallbox-status.model'

const fromWallboxStatusDtoToModelTransformer = (dto: WallboxStatusDto[]): WallboxStatusModel[] => {
  return dto.map(item => ({
    l1: item.L1,
    l2: item.L2,
    l3: item.L3,
    pvL1: item.PV_L1,
    pvL2: item.PV_L2,
    pvL3: item.PV_L3,
    deviceStatus: item.deviceStatus,
    id: item.id,
    moduleName: item.moduleName,
    wallboxId: item.serialno,
  }))
}

export default fromWallboxStatusDtoToModelTransformer
